import { ULoading } from '@/ui-component';
import { useOktaAuth } from '@okta/okta-react';
import { FC, useEffect } from 'react';
import { useSearchParams } from "react-router-dom";
import LogOutFromUD from './LogOutFromUD';
import {
  clearLocalStorage,
  userInitiatedOktaSignOut,
} from '@/core/config/okta.config';

const QUERY_PARAM_SOURCE_UD = "ud"
const Logout: FC = () => {
  const { oktaAuth } = useOktaAuth();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const isUDSource = searchParams?.get('source') === QUERY_PARAM_SOURCE_UD;

    /**
     * UD embed: revoke tokens, end Okta session without OIDC redirect, then clear storage (LogOutFromUD UI).
     * Default: full browser logout via OIDC sign-out + IdP redirect.
     */
    const handleLogout = async () => {
      if (isUDSource) {
        try {
          await oktaAuth.revokeAccessToken()
        } catch (err) {
          console.warn(
            "[Logout] revokeAccessToken failed or no token (continuing logout)",
            err,
          )
        }
        try {
          await oktaAuth.revokeRefreshToken()
        } catch (err) {
          console.warn(
            "[Logout] revokeRefreshToken failed or no token (continuing logout)",
            err,
          )
        }
        await oktaAuth.closeSession() // IdP session (shared SSO)
        await oktaAuth.tokenManager.clear()
        clearLocalStorage()
      } else {
        await userInitiatedOktaSignOut(oktaAuth)
      }
    };
  
    handleLogout();
  }, [oktaAuth, searchParams]);

  return (
    <>
      {(searchParams && searchParams.get('source')!=QUERY_PARAM_SOURCE_UD) ? (
        <ULoading isLoading={true} />
      ):(
        <LogOutFromUD/>
      )}
    </>
  )
};

export default Logout;
